export default __webpack_public_path__ + "static/media/BasicVideo3.18c7fa56.png";